<template>
  <div class="pros">
    <div class="title">
      <div class="a-t">新闻中心 <span>/ news center</span></div>
    </div>
    <div class="content">
      <a-spin v-if="loading" tip="Loading..."><div class="spin-content"></div></a-spin>
      <ul>
        <li v-for="(pro, index) in proList" :key="'pro' + index" :pId="pro.id" @click="toDetail">
          <div class="title">{{pro.title}}</div><div class="time">{{pro.time}}</div>
        </li>
      </ul>
      <div class="con-empty" v-if="isEmpty"><img src="../../assets/empty.png"/><br/><br/>暂时无数据…</div>
      <div class="paging">
        <a-pagination showSizeChanger :pageSize.sync="pageSize" @change="pageChange" @showSizeChange="onShowSizeChange" :total="total" v-model="current"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'pros',
  data () {
    return {
      loading: true,
      proList: [],
      current: 1,
      pageNo: 1,
      pageSize: 10,
      total: 500,
      tip: "",
      isEmpty: false
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      this.getList();
    },
    getList () {
      this.loading = true;
      this.proList = [];
      this.isEmpty = false;
      this.$store.dispatch('ajaxNewList',{
        actId: '0',
        pageIndex: this.pageNo,
				pageSize: this.pageSize
      }).then((result) => {
        this.total = result.totalCount;
        this.proList = result.data;
        this.loading = false;
        if(this.proList.length <= 0){
          this.isEmpty = true;
        }
      })
    },
    pageChange (page) {
      this.pageNo = page;
      this.getList();
    },
    onShowSizeChange() {
      this.getList();
    },
    changeNav (event) {
      var item = event.currentTarget,
          type = item.getAttribute('type');
      if(!item.classList.contains('active')){
        document.querySelector('.active').classList.remove('active');
        item.classList.add('active');
        this.tip = type;
        this.getList();
      }
    },
    toDetail () {
      var item = event.currentTarget,
          pId = item.getAttribute('pId');
      this.$router.push("newd/" + pId);
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/news';
</style>
